/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import _ from 'lodash';
import { labelerTableHead } from './LogBatchTableHead';

import TableGridWithFeatures from '../../../../../SharedModules/Table/TableGridWithFeatures';

import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';

import { setLogBatchTotalSelectListDetail } from '../../store/actions';
import { handleCommaSeparatedAmount } from '../../../../../SharedModules/CommonUtilities/commonUtilities.js';

function TableGridComponent(props) {
  const {
    onAddDetailAction,
    singleClickEdit,
    gridHeight,
    setFullScreenView,
    fullScreenView,
    logBatchList,
    setLoading,
    errorMessages,
    setErrorMessages,
    filterAction,
  } = props;

  const dispatch = useDispatch();
  const filterData = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.filterData
  );
  const gridRef = React.useRef();
  const [gridApi, setGridApi] = useState(gridRef);
  const [columnApi, setColumnApi] = useState(null);
  const [isFilter, setIsFilter] = useState(false);
  const [totalResultCount, setTotalResultCount] = useState(0);
  const [tableData, setTableData] = useState();
  const frameworkComponents = {
    CheckboxCell: (cellInfo) => {
      let checked = true;
       if (cellInfo.node?.data?.isBottomRow) {
        return null;
      }

      if (cellInfo.node?.data.cfFrozen == '0') {
        checked = false;
      }

      return (
        <>
          <div className="tbl-checkbox">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              disabled
              checked={checked}
              data-testid="log-batch-table-grid-checkbox"
              label="tbl-chkbox"
              className="frr-display-hidden-checkbox-label"
            />
          </div>
        </>
      );
    },
    CheckPayeeCell: (cellInfo) => {
      const name = cellInfo.data.checkPayeeCd;
      const isTotalsRow = cellInfo.data.isBottomRow;
    const style = {
    fontWeight: isTotalsRow ? 'bold' : 'normal',
    textAlign: isTotalsRow ? 'right' : 'left',
  };
      if (name && name.length > 25) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
        <div style={isTotalsRow ? { fontWeight: 'bold' } : {}}>{name}</div>
          </OverlayTrigger>
        );
      }
        return <div style={style}>{name}</div>;
    },
    TextFieldCell: (cellInfo) => {
      const name = cellInfo?.value;
      let boolRed = false;

      const nameAmt = name?.toString().replace('$', '').trim();

      if (nameAmt < 0) {
        boolRed = true;
      } else if (nameAmt > 0) {
        boolRed = false;
      }

      return (
        <div>
          {boolRed ? (
            <div style={{ color: 'red' }}>
              {`($ ${name})`.replace('-', '').trim()}
            </div>
          ) : (
            <div> {`${handleCommaSeparatedAmount(name)}`}</div>
          )}
        </div>
      );
    },
  };
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const onFilterChangedGrid = useCallback((e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    if (
      e.api.getFilterModel() &&
      Object.keys(e.api.getFilterModel()).length > 0
    ) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, []);

  const cellClickedListener = (e) => {
    setLoading(true);

    dispatch(
      setLogBatchTotalSelectListDetail({
        actionType: 'Update',
        orgData: e.data,
        updatedData: e.data,
      })
    );
    onAddDetailAction('Update');
  };
  const createData = (count) => {
    const result = [];
    let totCheckCnt=0;
    let totCheckAmt=0;
    logBatchList.map((dt)=>{
      totCheckCnt=totCheckCnt+parseFloat(dt?.totCheckCnt)
            totCheckAmt=totCheckAmt+parseFloat(dt?.totCheckAmt)

    })
    for (let i = 0; i < count; i += 1) {
      result.push({
        detailLevel:'',
        checkPayeeCd:'Totals:',
        totCheckCnt:totCheckCnt,
        totCheckAmt:totCheckAmt,
        isBottomRow: true,
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    if(Array.isArray(logBatchList)&&logBatchList?.length>0&&logBatchList?.[logBatchList?.length-1]?.qtr!=='Total'){

      return createData(1);
    }
    }, [logBatchList]);
  return (
    <div data-testid="Logbatch-table-grid-component">
      {fullScreenView ? (
        <div className="full-view-page-title">Log Batch</div>
      ) : (
        <>
          <div className="filter-checkbox">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Show completed batches"
              onChange={(e) =>
                filterAction(
                  'batchCompleteStatus',
                  filterData.batchCompleteStatus !== 'C' ? 'C' : ''
                )
              }
              checked={filterData.batchCompleteStatus === 'C'}
              data-testid="show-completed-batches-checkbox"
            />
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Show incomplete batches"
              onChange={(e) =>
                filterAction(
                  'batchInCompleteStatus',
                  filterData.batchInCompleteStatus !== 'I' ? 'I' : ''
                )
              }
              checked={filterData.batchInCompleteStatus === 'I'}
              data-testid="show-incomplete-batches-checkbox"
            />
          </div>
          <div className="clearfix" />
        </>
      )}

      <TableGridWithFeatures
        rowSelection="single"
        rowMultiSelectWithClick={false}
        frameworkComponents={frameworkComponents}
        rowData={logBatchList}
        suppressMenuHide
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        exportFile
        columnDefs={labelerTableHead}
        gridHeight={gridHeight}
        animateRows
        sideBar={false}
        domLayout="autoHeight"
        cellClickedListener={cellClickedListener}
        singleClickEdit={singleClickEdit || false}
        suppressNavigation={suppressNavigation}
        onFilterChanged={onFilterChangedGrid}
        data-testid="log-batch-total-table-grid"
        setTotal={setTotalResultCount}
        fileName="Log Batch Total"
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        pinnedBottomRowData={pinnedBottomRowData}
      />
      {/* <div className="row">
        <div className="col-12 welcometxt">
          <p className="no-margin tbl-help-text ">
            * On Double Click of Results, system should navigate to Detail page
          </p>
        </div>
      </div> */}
    </div>
  );
}

export default TableGridComponent;
